import { render } from "./InputTextarea.vue?vue&type=template&id=73114805&scoped=true&ts=true"
import script from "./InputTextarea.vue?vue&type=script&lang=ts"
export * from "./InputTextarea.vue?vue&type=script&lang=ts"

import "./InputTextarea.vue?vue&type=style&index=0&id=73114805&lang=scss&scoped=true"

import exportComponent from "E:\\vue_test\\form-gpt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73114805"]])

export default __exports__